import React, { Component } from 'react';
import classNames from 'classnames';
import RcInputNumber from '../rc-components/input-number';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
export default class InputNumber extends Component {
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { className, size, prefixCls: customizePrefixCls, ...others } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('input-number', customizePrefixCls);
        const inputNumberClass = classNames({
            [`${prefixCls}-lg`]: size === Size.large,
            [`${prefixCls}-sm`]: size === Size.small,
        }, className);
        return (React.createElement(RcInputNumber, Object.assign({ ref: (c) => (this.inputNumberRef = c), className: inputNumberClass, prefixCls: prefixCls }, others)));
    }
    focus() {
        this.inputNumberRef.focus();
    }
    blur() {
        this.inputNumberRef.blur();
    }
}
InputNumber.displayName = 'InputNumber';
InputNumber.defaultProps = {
    step: 1,
};
